import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import ItemListContext from './ItemListContext';

var ItemListController = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ItemListController, _Component);

  function ItemListController() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "highlightedItemId", null);

    return _this;
  }

  var _proto = ItemListController.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.unsubsribeController = this.itemList.subscribeController(this);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unsubsribeController();
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ItemListContext.Consumer, null, function (itemList) {
      if (!_this2.itemList) {
        _this2.itemList = itemList;
      }

      return _this2.props.children(_objectSpread(_objectSpread({}, itemList), {}, {
        highlightedItemId: _this2.highlightedItemId
      }));
    });
  };

  return ItemListController;
}(Component);

export default ItemListController;